import React, { useState, useEffect, useRef } from "react";
import "./Connectfour.css";
import { Container, Row, Col, Button, ButtonGroup } from "react-bootstrap";
import useUserInfo from "../../../Hooks/useUserInfo";
import { useAudio } from "../../../Providers/AudioProvider";
import { userGameRewards } from "../../../apis/user";
import task from "../../Task/Task";
import { logPageView } from "../../../components/analytics";
import { io } from "socket.io-client";
import { Base_Url } from "../../../apis/baseurl";
const ConnectFourWeb = () => {
  const ROWS = 6;
  const COLS = 7;
  const EMPTY = null;
  const PLAYER_RED = "red";
  const PLAYER_YELLOW = "yellow";

  function createEmptyBoard() {
    return Array(ROWS)
      .fill()
      .map(() => Array(COLS).fill(EMPTY));
  }

  const { userDetails, updateUserInfo, watchScreen, updatewatchScreenInfo } =
    useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [socket, setSocket] = useState(null);
  const [board, setBoard] = useState(createEmptyBoard());
  const [currentPlayer, setCurrentPlayer] = useState(PLAYER_RED);
  const [winner, setWinner] = useState(null);
  const [isDraw, setIsDraw] = useState(false);
  const [winningCells, setWinningCells] = useState([]);
  const [isDropping, setIsDropping] = useState(false);
  const [lastCol, setLastCol] = useState(null);
  const [points, setPoints] = useState(0);
  const [playerColor, setPlayerColor] = useState(null);
  const [roomId, setRoomId] = useState(null);
  const [isMyTurn, setIsMyTurn] = useState(false);
  const [gameStatus, setGameStatus] = useState("waiting");
  const [lastMove, setLastMove] = useState(null);
  const playClick = useAudio();
  const [copySuccess, setCopySuccess] = useState("");
  const [inputRoomId, setInputRoomId] = useState("");
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);
  const waitingTimerRef = useRef(null);
  const [players, setPlayers] = useState([]);
  const [currentPlayerId, setCurrentPlayerId] = useState(null);
  const [redTime, setRedTime] = useState(300);
  const [yellowTime, setYellowTime] = useState(300);
  const [timerActive, setTimerActive] = useState(false);
  const timerRef = useRef(null);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [pointsAwarded, setPointsAwarded] = useState(false);
  const [gameEndedByWin, setGameEndedByWin] = useState(false);
  const [pointsAwardedByWin, setPointsAwardedByWin] = useState(false);
  const [pointsAwardedByDisconnect, setPointsAwardedByDisconnect] =
    useState(false);
  const [backButtonPressed, setBackButtonPressed] = useState(false);
  const apiCallInProgress = useRef(false);
  const pointsAwardedRef = useRef(false);

  useEffect(() => {
    logPageView("ConnectFourWebPage", "Connect Four Multiplayer Game");
  }, []);

  // Initialize socket connection
  useEffect(() => {
    const newSocket = io(Base_Url.base_url, {
      auth: {
        token: localStorage.getItem("token"),
      },
    });
    setSocket(newSocket);

    newSocket.on("connect", () => {
      // Connected to server
    });

    newSocket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    return () => newSocket.disconnect();
  }, []);

  // Socket event listeners
  useEffect(() => {
    if (!socket) return;

    socket.on("gameState", (gameState) => {
      // Check if this is an opponent's move (board changed and it's not my turn)
      const isOpponentMove =
        gameState.board &&
        gameState.currentPlayer !== socket.id &&
        gameState.lastMove &&
        gameState.gameStatus === "playing";

      // Update local game state based on server data
      if (gameState.board) {
        // Opponent's move - no animation needed
        setBoard(gameState.board);
      }
      if (gameState.players) {
        setPlayers(gameState.players);
        // Determine player color based on position in players array
        const playerIndex = gameState.players.indexOf(socket.id);
        setPlayerColor(playerIndex === 0 ? PLAYER_RED : PLAYER_YELLOW);
      }
      if (gameState.currentPlayer) {
        setCurrentPlayerId(gameState.currentPlayer);
        setIsMyTurn(gameState.currentPlayer === socket.id);
      }
      if (gameState.gameStatus) setGameStatus(gameState.gameStatus);
      if (gameState.roomId) setRoomId(gameState.roomId);
      if (gameState.lastMove) setLastMove(gameState.lastMove);
      if (gameState.winner) setWinner(gameState.winner);
      if (gameState.isDraw) setIsDraw(gameState.isDraw);
      if (gameState.winningCells) setWinningCells(gameState.winningCells);
      if (gameState.redTime !== undefined) setRedTime(gameState.redTime);
      if (gameState.yellowTime !== undefined)
        setYellowTime(gameState.yellowTime);
      // Handle game status changes
      if (gameState.gameStatus === "playing" && players.length === 2) {
        setIsMyTurn(gameState.currentPlayer === socket.id);
        setCurrentPlayerId(gameState.currentPlayer);
        // Start timer if game just started
        if (!timerActive) {
          setTimerActive(true);
        }

        // Ensure timer is active when turn changes
        if (gameState.currentPlayer !== currentPlayerId) {
          setTimerActive(true);
        }
      }
      // Handle game over state
      if (gameState.gameStatus === "finished") {
        setTimerActive(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        if (gameState.winner === "Draw" || gameState.winner === "draw") {
          // Handle draw scenario
          setWinner("Draw");
          setIsDraw(true);
          if (!pointsAwarded) {
            const drawPoints = 0;
            setPoints(drawPoints);
            setTimeout(() => {
              handleApiResponse(drawPoints.toString());
            }, 3000);
          } else {
            setGameStatus("finished");
          }
        } else if (gameState.winner === "Disconnected") {
          console.log("🔌 gameState winner === 'Disconnected' event fired");
          console.log("🔌 pointsAwarded:", pointsAwarded);
          console.log("🔌 pointsAwardedRef.current:", pointsAwardedRef.current);
          // Handle disconnection - only update UI, don't call API (already handled by playerLeft)
          setWinner("Disconnected");
          setGameStatus("finished");
        } else if (gameState.winner) {
          console.log("🏆 gameState winner event fired");
          console.log("🏆 winner socket ID:", gameState.winner);
          console.log("🏆 current socket ID:", socket.id);
          console.log("🏆 pointsAwarded:", pointsAwarded);
          console.log("🏆 pointsAwardedRef.current:", pointsAwardedRef.current);

          // Convert socket ID back to color for display
          const winnerPlayerIndex = gameState.players.indexOf(gameState.winner);
          const winnerColor =
            winnerPlayerIndex === 0 ? PLAYER_RED : PLAYER_YELLOW;
          setWinner(winnerColor);

          // Calculate score based on winner - only if points haven't been awarded yet
          if (!pointsAwarded && !pointsAwardedRef.current) {
            if (gameState.winner === socket.id) {
              console.log("🎉 Current player won - awarding points");
              // Current player won
              const winPoints =
                userDetails && userDetails.earlyUsersLimitReached
                  ? 1000
                  : userDetails
                  ? 2000
                  : 1000;

              setPoints(winPoints);

              // Set refs FIRST to prevent duplicate API calls
              pointsAwardedRef.current = true;
              apiCallInProgress.current = true;
              setPointsAwarded(true);

              // Add a small delay to ensure game state is visible before API call
              setTimeout(() => {
                handleApiResponse(winPoints.toString());
              }, 3000); // 1 second delay
            } else {
              console.log("😞 Current player lost - awarding 0 points");
              // Current player lost
              const losePoints = 0;
              setPoints(losePoints);

              // Set refs FIRST to prevent duplicate API calls
              pointsAwardedRef.current = true;
              apiCallInProgress.current = true;
              setPointsAwarded(true);

              // Add a small delay to ensure game state is visible before API call
              setTimeout(() => {
                handleApiResponse(losePoints.toString());
              }, 3000); // 1 second delay
            }
          } else {
            console.log("⚠️ Points already awarded, skipping API call");
            // If points already awarded, set game status to finished immediately
            setGameStatus("finished");
          }
        } else {
          // Fallback for no winner specified
          setWinner("Draw");
          setIsDraw(true);
          if (!pointsAwarded) {
            const drawPoints = 0;
            setPoints(drawPoints);
            setTimeout(() => {
              handleApiResponse(drawPoints.toString());
            }, 3000);
          } else {
            setGameStatus("finished");
          }
        }
      }
    });

    socket.on("playerJoined", ({ players, roomId }) => {
      setPlayers(players);
      setRoomId(roomId);

      // If we have 2 players, start the game
      if (players.length === 2) {
        const newBoard = createEmptyBoard();
        const initialGameState = {
          board: newBoard,
          players: players,
          currentPlayer: players[0], // First player starts
          gameStatus: "playing",
          roomId: roomId,
          lastMove: null,
          winner: null,
          isDraw: false,
          winningCells: [],
          redTime: 300,
          yellowTime: 300,
        };

        // Set local state immediately
        setBoard(newBoard);
        setGameStatus("playing");
        setTimerActive(true);
        setRedTime(300);
        setYellowTime(300);

        // Determine player color and turn
        const isRoomCreator = players[0] === socket.id;
        const assignedColor = isRoomCreator ? PLAYER_RED : PLAYER_YELLOW;

        setPlayerColor(assignedColor);
        setIsMyTurn(isRoomCreator);
        setCurrentPlayerId(players[0]);

        // Emit the initial game state to all players
        socket.emit("updateGameState", initialGameState);
      }
    });

    socket.on("playerLeft", () => {
      console.log("🔌 playerLeft event fired");
      console.log("🔌 gameStatus:", gameStatus);
      console.log("🔌 pointsAwarded:", pointsAwarded);
      console.log("🔌 pointsAwardedRef.current:", pointsAwardedRef.current);

      // Only show disconnect message if game wasn't already finished
      if (
        gameStatus !== "finished" &&
        !pointsAwarded &&
        !pointsAwardedRef.current
      ) {
        console.log("✅ Processing playerLeft - awarding 0 points");
        setWinner("Disconnected");

        // No points awarded for disconnect - only 0 points
        const disconnectPoints = 0;
        setPoints(disconnectPoints);

        // Set refs FIRST to prevent duplicate API calls
        pointsAwardedRef.current = true;
        apiCallInProgress.current = true;
        setPointsAwarded(true);

        // Set game status to finished immediately
        setGameStatus("finished");

        // Stop timer
        setTimerActive(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }

        // Send game over state to server
        const disconnectedGameState = {
          board: board,
          players: players,
          currentPlayer: currentPlayerId,
          gameStatus: "finished",
          roomId: roomId,
          lastMove: lastMove,
          winner: "Disconnected",
          isDraw: false,
          winningCells: [],
          redTime: redTime,
          yellowTime: yellowTime,
          points: {
            winner: 0,
            loser: 0,
            winnerSocketId: null,
            loserSocketId: null,
          },
        };
        socket.emit("updateGameState", disconnectedGameState);

        // Call API for disconnect - 0 points
        setTimeout(() => {
          handleApiResponse(disconnectPoints.toString());
        }, 1000);
      }
    });

    socket.on("roomFull", () => {
      alert("Room is full. Please try another room.");
    });

    socket.on("roomExpired", (data) => {
      // Check if this is the current user's room (timeout) or someone trying to join an expired room
      if (roomId === data.roomId) {
        // This is the current user's room expiring due to timeout
        // Don't reset showTimeoutPopup here - let the timeout popup stay visible
        setBoard(createEmptyBoard());
        setRoomId(null);
        setGameStatus("initial");
        setWinner(null);
        setIsDraw(false);
        setWinningCells([]);
        setLastCol(null);
        setPlayerColor(null);
        setInputRoomId("");
        // Don't reset showTimeoutPopup - let it stay visible
        setPlayers([]);
        setCurrentPlayerId(null);
        setRedTime(300);
        setYellowTime(300);
        setTimerActive(false);
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
        if (waitingTimerRef.current) {
          clearTimeout(waitingTimerRef.current);
          waitingTimerRef.current = null;
        }
      } else {
        // Someone is trying to join an expired room
        alert(data.message || "This room has expired and cannot be joined.");
      }
    });

    socket.on("roomDeleted", (data) => {
      // Room has been successfully deleted
    });

    socket.on("error", (error) => {
      alert(error || "An error occurred. Please try again.");
    });

    return () => {
      socket.off("gameState");
      socket.off("playerJoined");
      socket.off("playerLeft");
      socket.off("roomFull");
      socket.off("roomExpired");
      socket.off("roomDeleted");
      socket.off("error");
    };
  }, [socket, players, pointsAwarded]);

  // Setup waiting timer when room is created/joined
  useEffect(() => {
    // Clear any existing timer
    if (waitingTimerRef.current) {
      clearTimeout(waitingTimerRef.current);
      waitingTimerRef.current = null;
    }

    // Set a new timer if we're in waiting state with a room ID
    if (gameStatus === "waiting" && roomId) {
      waitingTimerRef.current = setTimeout(() => {
        setShowTimeoutPopup(true);
        // Expire the room when timeout occurs
        if (socket) {
          socket.emit("expireRoom", { roomId: roomId });
        }
      }, 120000); // 120 seconds
    }

    // Clear timer when game starts or component unmounts
    return () => {
      if (waitingTimerRef.current) {
        clearTimeout(waitingTimerRef.current);
      }
    };
  }, [gameStatus, roomId]);

  // Clear timer when game starts
  useEffect(() => {
    if (gameStatus === "playing" && waitingTimerRef.current) {
      clearTimeout(waitingTimerRef.current);
      waitingTimerRef.current = null;
    }
  }, [gameStatus]);

  // Timer logic - simplified and more reliable
  useEffect(() => {
    // Clear any existing timer first
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    if (gameStatus === "playing" && timerActive && !winner && !isDraw) {
      timerRef.current = setInterval(() => {
        // Update the timer for the current player and sync with server
        if (currentPlayerId === socket?.id) {
          if (playerColor === PLAYER_RED) {
            setRedTime((prev) => {
              if (prev <= 1) {
                handleTimeout(PLAYER_YELLOW);
                return 0;
              }
              const newTime = prev - 1;

              // Emit timer update to server for synchronization
              if (socket && roomId) {
                socket.emit("updateGameState", {
                  board,
                  players,
                  currentPlayer: currentPlayerId,
                  gameStatus: "playing",
                  roomId,
                  lastMove,
                  winner: null,
                  isDraw: false,
                  winningCells: [],
                  redTime: newTime,
                  yellowTime,
                });
              }

              return newTime;
            });
          } else {
            setYellowTime((prev) => {
              if (prev <= 1) {
                handleTimeout(PLAYER_RED);
                return 0;
              }
              const newTime = prev - 1;

              // Emit timer update to server for synchronization
              if (socket && roomId) {
                socket.emit("updateGameState", {
                  board,
                  players,
                  currentPlayer: currentPlayerId,
                  gameStatus: "playing",
                  roomId,
                  lastMove,
                  winner: null,
                  isDraw: false,
                  winningCells: [],
                  redTime,
                  yellowTime: newTime,
                });
              }

              return newTime;
            });
          }
        }
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [
    gameStatus,
    timerActive,
    winner,
    isDraw,
    currentPlayerId,
    playerColor,
    socket?.id,
  ]);

  function checkWinner(board, row, col, player) {
    const directions = [
      [0, 1], // horizontal
      [1, 0], // vertical
      [1, 1], // diagonal down-right
      [1, -1], // diagonal down-left
    ];

    for (const [dx, dy] of directions) {
      let count = 1;
      const winningCells = [{ row, col }];

      // Check in positive direction
      for (let i = 1; i < 4; i++) {
        const newRow = row + i * dx;
        const newCol = col + i * dy;
        if (
          newRow >= 0 &&
          newRow < ROWS &&
          newCol >= 0 &&
          newCol < COLS &&
          board[newRow][newCol] === player
        ) {
          count++;
          winningCells.push({ row: newRow, col: newCol });
        } else {
          break;
        }
      }

      // Check in negative direction
      for (let i = 1; i < 4; i++) {
        const newRow = row - i * dx;
        const newCol = col - i * dy;
        if (
          newRow >= 0 &&
          newRow < ROWS &&
          newCol >= 0 &&
          newCol < COLS &&
          board[newRow][newCol] === player
        ) {
          count++;
          winningCells.push({ row: newRow, col: newCol });
        } else {
          break;
        }
      }

      if (count >= 4) {
        return winningCells;
      }
    }

    return null;
  }

  function isBoardFull(board) {
    return board[0].every((cell) => cell !== EMPTY);
  }

  function isWinningcell(rowIndex, colIndex) {
    return winningCells.some(
      (wc) => wc.row === rowIndex && wc.col === colIndex
    );
  }

  // Check if a cell is the topmost empty cell in its column
  const isTopEmptyCell = (row, col) => {
    // If the current cell is not empty, it's not a valid drop target
    if (board[row][col]) return false;

    // Check if all cells above this one are also empty
    for (let i = 0; i < row; i++) {
      if (board[i][col]) return false;
    }

    return true;
  };

  function getLowestEmptyRow(board, col) {
    for (let row = ROWS - 1; row >= 0; row--) {
      if (board[row][col] === EMPTY) {
        return row;
      }
    }
    return -1;
  }

  function handleTimeout(winnerColor) {
    setWinner(winnerColor);
    setGameEndedByWin(true);
    setTimerActive(false);
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    // No points awarded for timeout - only 0 points
    if (!pointsAwarded && !apiCallInProgress.current) {
      const timeoutPoints = 0;
      setPointsAwarded(true);
      setPoints(timeoutPoints);

      // Add a small delay to ensure timeout state is visible before API call
      setTimeout(() => {
        handleApiResponse(timeoutPoints.toString());
      }, 1000);
    }

    // Emit game state to notify opponent about timeout
    if (socket && roomId) {
      // Convert winner color to socket ID for backend
      let winnerSocketId = null;
      if (winnerColor) {
        const winnerPlayerIndex = winnerColor === PLAYER_RED ? 0 : 1;
        winnerSocketId = players[winnerPlayerIndex];
      }

      // No points awarded for timeout scenario
      const winnerPoints = 0;
      const loserPoints = 0;

      const updatedGameState = {
        board,
        players,
        currentPlayer: players.find((id) => id !== currentPlayerId),
        gameStatus: "finished",
        roomId,
        lastMove,
        winner: winnerSocketId, // Send socket ID instead of color
        isDraw: false,
        winningCells: [],
        redTime,
        yellowTime,
        points: {
          winner: winnerPoints,
          loser: loserPoints,
          winnerSocketId: winnerSocketId,
          loserSocketId: winnerSocketId
            ? players.find((id) => id !== winnerSocketId)
            : null,
        },
      };
      socket.emit("updateGameState", updatedGameState);
    }
  }

  function handleColumnClick(col) {
    if (!isMyTurn || gameStatus !== "playing" || winner || isDraw) return;

    const newBoard = [...board];
    const row = getLowestEmptyRow(newBoard, col);

    if (row === -1) return;

    // Update board immediately
    newBoard[row][col] = playerColor;
    setBoard(newBoard);
    setLastCol(col);
    setIsDropping(true);

    const winningCells = checkWinner(newBoard, row, col, playerColor);
    if (winningCells) {
      setWinner(playerColor);
      setWinningCells(winningCells);
      setGameEndedByWin(true);
      setTimerActive(false);
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      // Only award points if not already awarded and no API call in progress
      if (!pointsAwarded && !apiCallInProgress.current) {
        const winPoints =
          userDetails && userDetails.earlyUsersLimitReached
            ? 1000
            : userDetails
            ? 2000
            : 1000;

        setPointsAwarded(true);
        setPoints(winPoints);

        // Add a small delay to ensure winning move is visible before API call
        setTimeout(() => {
          handleApiResponse(winPoints.toString());
        }, 1000); // 1 second delay
      } else {
      }
    } else if (isBoardFull(newBoard)) {
      setIsDraw(true);
      setTimerActive(false);
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      // Only award points if not already awarded and no API call in progress
      if (!pointsAwarded && !apiCallInProgress.current) {
        const drawPoints = 0;
        setPointsAwarded(true);
        setPoints(drawPoints);

        // Add a small delay to ensure draw state is visible before API call
        setTimeout(() => {
          handleApiResponse(drawPoints.toString());
        }, 1000); // 1 second delay
      } else {
      }
    } else {
      const nextPlayer = players.find((id) => id !== currentPlayerId);
      setIsMyTurn(false);
      setCurrentPlayerId(nextPlayer);

      // Switch timer to other player
      setTimerActive(false);
      setTimeout(() => setTimerActive(true), 100);
    }

    if (socket && roomId) {
      // Convert winner color to socket ID for backend
      let winnerSocketId = null;
      if (winningCells) {
        // Find the socket ID of the player who has the winning color
        const winnerPlayerIndex = playerColor === PLAYER_RED ? 0 : 1;
        winnerSocketId = players[winnerPlayerIndex];
      } else if (isBoardFull(newBoard)) {
        winnerSocketId = "Draw";
      }

      // Calculate points for each player
      let winnerPoints = 0;
      let loserPoints = 0;
      if (winningCells) {
        // Someone won
        winnerPoints =
          userDetails && userDetails.earlyUsersLimitReached ? 1000 : 2000;
        loserPoints = 0;
      } else if (isBoardFull(newBoard)) {
        // Draw
        winnerPoints = 0;
        loserPoints = 0;
      }

      const updatedGameState = {
        board: newBoard,
        players,
        currentPlayer: players.find((id) => id !== currentPlayerId),
        gameStatus:
          winningCells || isBoardFull(newBoard) ? "finished" : "playing",
        roomId,
        lastMove: { row, col, player: playerColor },
        winner: winnerSocketId, // Send socket ID instead of color
        isDraw: isBoardFull(newBoard) && !winningCells,
        winningCells: winningCells || [],
        redTime,
        yellowTime,
        points: {
          winner: winnerPoints,
          loser: loserPoints,
          winnerSocketId: winnerSocketId,
          loserSocketId: winnerSocketId
            ? players.find((id) => id !== winnerSocketId)
            : null,
        },
      };

      socket.emit("updateGameState", updatedGameState);
    }

    setTimeout(() => {
      setIsDropping(false);
    }, 300);
  }

  const handleApiResponse = async (points) => {
    console.log("🔍 handleApiResponse called with points:", points);
    console.log("🔍 pointsAwardedRef.current:", pointsAwardedRef.current);
    console.log("🔍 apiCallInProgress.current:", apiCallInProgress.current);
    console.log("🔍 pointsAwarded state:", pointsAwarded);

    // Prevent multiple API calls for the same game using ref for immediate check
    if (pointsAwardedRef.current || apiCallInProgress.current) {
      console.log(
        "❌ API call blocked - already in progress or points awarded"
      );
      return;
    }

    // Set flags immediately to prevent concurrent calls
    apiCallInProgress.current = true;
    pointsAwardedRef.current = true;
    console.log("✅ API call proceeding with points:", points);

    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    try {
      const apiData = {
        gamePoints: points,
        gameType: "ConnectFourWeb",
      };
      console.log("📤 Sending API request:", apiData);
      const res = await userGameRewards(apiData);

      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setPointsAwarded(true);
        // Set game status to finished AFTER API call is complete
        setGameStatus("finished");
      }
    } catch (error) {
      console.error("API call failed:", error);
      // Even if API call fails, set game status to finished
      setGameStatus("finished");
    } finally {
      // Reset the flag after API call completes
      apiCallInProgress.current = false;
    }
  };

  const generateRoomId = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  // Reset all game state to initial values
  const resetGameState = (gameStatus = "waiting") => {
    setRoomId(null);
    setGameStatus(gameStatus);
    setWinner(null);
    setIsDraw(false);
    setWinningCells([]);
    setLastCol(null);
    setPlayerColor(null);
    setInputRoomId("");
    setShowTimeoutPopup(false);
    setPlayers([]);
    setCurrentPlayerId(null);
    setPoints(0);
    setPointsAwarded(false);
    setGameEndedByWin(false);
    setPointsAwardedByWin(false);
    setPointsAwardedByDisconnect(false);
    setBackButtonPressed(false);
    apiCallInProgress.current = false;
    pointsAwardedRef.current = false;
    setRedTime(300);
    setYellowTime(300);
    setTimerActive(false);
    if (timerRef.current) clearInterval(timerRef.current);
  };

  const startNewGame = () => {
    const newRoomId = generateRoomId();
    // Reset all game states to initial values
    setBoard(createEmptyBoard());
    resetGameState("waiting");
    setRoomId(newRoomId);
    socket.emit("joinRoom", { roomId: newRoomId, gameType: "connectfour" });
  };

  const joinGame = (roomIdToJoin) => {
    if (!roomIdToJoin) {
      alert("Please enter a Room ID");
      return;
    }

    setBoard(createEmptyBoard());
    resetGameState("waiting");
    socket.emit("joinRoom", { roomId: roomIdToJoin, gameType: "connectfour" });
  };

  const startOverNewGame = () => {
    // Reset all game states to initial values
    setBoard(createEmptyBoard());
    resetGameState("initial"); // Set to 'initial' instead of 'waiting'
  };

  const toogleMenu = () => {
    playClick();

    // If room is created but no players have joined yet, go back to multiplayer options
    if (roomId && gameStatus === "waiting") {
      if (socket && roomId) {
        socket.emit("leaveRoom", { roomId: roomId });
      }
      setRoomId(null);
      setGameStatus("initial");
      setWinner(null);
      setTimerActive(false);
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      return;
    }

    if (
      roomId &&
      gameStatus === "playing" &&
      !winner &&
      !isDraw &&
      !pointsAwarded &&
      players.length === 2
    ) {
      console.log(
        "🔙 Back button pressed - awarding 0 points (no points for back button)"
      );
      console.log("🔙 pointsAwarded:", pointsAwarded);
      console.log("🔙 pointsAwardedRef.current:", pointsAwardedRef.current);

      // No points awarded for back button - only 0 points
      const backButtonPoints = 0;
      setPoints(backButtonPoints);

      // Set refs FIRST to prevent duplicate API calls
      pointsAwardedRef.current = true;
      apiCallInProgress.current = true;
      setPointsAwarded(true);

      handleApiResponse(backButtonPoints.toString());

      // Emit game state to notify opponent
      if (socket && roomId) {
        const opponentId = players.find((id) => id !== socket.id);
        const opponentColor =
          playerColor === PLAYER_RED ? PLAYER_YELLOW : PLAYER_RED;

        // Convert opponent color to socket ID for backend
        const opponentPlayerIndex = opponentColor === PLAYER_RED ? 0 : 1;
        const opponentSocketId = players[opponentPlayerIndex];

        // No points awarded for back button scenario
        const opponentWinPoints = 0;
        const currentPlayerPoints = 0;

        const updatedGameState = {
          board,
          players,
          currentPlayer: opponentId,
          gameStatus: "finished",
          roomId,
          winner: opponentSocketId, // Send opponent's socket ID
          isDraw: false,
          winningCells: [],
          redTime,
          yellowTime,
          points: {
            winner: opponentWinPoints,
            loser: currentPlayerPoints,
            winnerSocketId: opponentSocketId,
            loserSocketId: socket.id,
          },
        };
        socket.emit("updateGameState", updatedGameState);
        socket.emit("leaveRoom", { roomId: roomId });
      }

      // Set game over state to show points popup briefly, then navigate back
      setWinner("Opponent");
      setGameStatus("finished");
      setTimerActive(false);
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      // Navigate back immediately after setting game state
      updateUserInfo((prev) => ({
        ...prev,
        isPlay: false,
        currentComponent: task,
        currentComponentText: "task",
        lastComponent: userDetails?.userDetails.currentComponent,
        lastComponentText: userDetails?.userDetails.currentComponentText,
        isMenu: true,
        menuCount: userDetails?.userDetails?.menuCount + 1,
      }));
    } else if (roomId) {
      // Game is finished, waiting, only one player, or points already awarded - just leave without awarding points

      if (socket && roomId) {
        socket.emit("leaveRoom", { roomId: roomId });
      }
      setRoomId(null);
      setGameStatus("waiting");
      setWinner(null);
      setTimerActive(false);
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    } else {
      updateUserInfo((prev) => ({
        ...prev,
        isPlay: false,
        currentComponent: task,
        currentComponentText: "task",
        lastComponent: userDetails?.userDetails.currentComponent,
        lastComponentText: userDetails?.userDetails.currentComponentText,
        isMenu: true,
        menuCount: userDetails?.userDetails?.menuCount + 1,
      }));
    }
  };

  const navigateToSinglePlayer = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: true,
      currentComponent: require("../Connectfour/Connectfour").default,
      currentComponentText: "connectfour",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
    }));
  };

  const copyRoomId = () => {
    navigator.clipboard.writeText(roomId).then(
      () => {
        setCopySuccess("Copied!");
        setTimeout(() => setCopySuccess(""), 2000);
      },
      (err) => {
        // Could not copy text
      }
    );
  };

  return (
    <>
      {/* CSS Animations for turn indicators */}
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.7; }
            100% { opacity: 1; }
          }
          
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-10px); }
            60% { transform: translateY(-5px); }
          }
          
          @keyframes timerBorder {
            0% { 
              background: conic-gradient(#dc3545 0deg, transparent 0deg);
            }
            100% { 
              background: conic-gradient(#dc3545 360deg, transparent 360deg);
            }
          }
          
          @keyframes timerBorderYellow {
            0% { 
              background: conic-gradient(#ffc107 0deg, transparent 0deg);
            }
            100% { 
              background: conic-gradient(#ffc107 360deg, transparent 360deg);
            }
          }
          
          .text-pulse {
            animation: textPulse 1.5s ease-in-out infinite;
          }
          
          @keyframes textPulse {
            0% { 
              opacity: 1;
              transform: scale(1);
            }
            50% { 
              opacity: 0.7;
              transform: scale(1.05);
            }
            100% { 
              opacity: 1;
              transform: scale(1);
            }
          }
          
          .animate-pulse {
            animation: pulse 2s infinite;
          }
          
          .cell1.hover-highlight:hover {
            background-color: rgba(40, 167, 69, 0.2) !important;
            border-color: #28a745 !important;
          }
          
          .cell1.hover-highlight:hover .piece {
            background-color: unset !important;
            border-color: unset !important;
            box-shadow: unset !important;
          }
          
          .drop-indicator {
            animation: bounce 1s infinite;
          }
          
          .turn-indicator {
            animation: pulse 2s infinite;
          }
        `}
      </style>

      <Container fluid className="game-container p-0">
        {/* Hide back button when showing room ID copy page */}
        {!(roomId && gameStatus === "waiting") && (
          <img
            onClick={toogleMenu}
            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
            className="cancel-full"
            style={{ cursor: "pointer" }}
          />
        )}

        {/* Info Button */}
        <button
          onClick={() => setShowInfoPopup(true)}
          className="connect-four-info-button"
          title="Game Info"
        >
          ℹ️
        </button>

        {(gameStatus === "waiting" || gameStatus === "initial") && !roomId && (
          <Row className="justify-content-center align-items-center min-vh-100 m-0">
            <Col xs={12} md={8} lg={12} className="p-4">
              <div className="connect-four rounded-4 shadow-lg p-2">
                <div className="text-center mb-4">
                  <h2
                    className="text-uppercase text-white welcome-text mb-2"
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                      // textShadow: "0 0 20px rgba(0, 255, 65, 0.8)",

                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Connect Four
                  </h2>
                  <h3
                    className="text-uppercase text-white mb-0"
                    style={{
                      fontSize: "1.2rem",
                      color: "#39ff14",
                      textShadow: "0 0 10px rgba(57, 255, 20, 0.5)",
                    }}
                  >
                    Multiplayer Battle
                  </h3>
                </div>

                <div className="d-flex flex-column gap-3 mb-4">
                  <button
                    onClick={startNewGame}
                    className="btn w-100 py-2"
                    disabled={!socket}
                    style={{
                      background: "#04720b",
                      border: "0.5px solid #4cf03852",

                      borderRadius: "10px",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "1rem",
                      textTransform: "uppercase",
                      // boxShadow: "0 8px 16px rgba(0, 255, 65, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 12px 24px rgba(0, 255, 65, 0.4)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 8px 16px rgba(0, 255, 65, 0.3)";
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-center">
                      <span className="me-3" style={{ fontSize: "1.5rem" }}>
                        🎮
                      </span>
                      <span>Create New Room</span>
                    </div>
                  </button>

                  <button
                    onClick={navigateToSinglePlayer}
                    className="btn w-100 py-2"
                    style={{
                      background: "#04720b",
                      border: "0.5px solid #4cf03852",
                      borderRadius: "10px",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "1rem",
                      textTransform: "uppercase",
                      // boxShadow: "0 8px 16px rgba(34, 139, 34, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 12px 24px rgba(34, 139, 34, 0.4)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 8px 16px rgba(34, 139, 34, 0.3)";
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-center">
                      <span className="me-3" style={{ fontSize: "1.5rem" }}>
                        🖥️
                      </span>
                      <span>Play With THEMEMETV</span>
                    </div>
                  </button>
                </div>

                <div
                  className="join-game-section"
                  style={{
                    background: "rgba(0, 255, 65, 0.1)",
                    borderRadius: "15px",
                    padding: "20px",
                    border: "1px solid rgb(0 255 65 / 11%)",
                  }}
                >
                  <h4
                    className="text-center mb-3"
                    style={{
                      color: "rgb(254 254 254)",
                      fontSize: "1.3rem",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      textShadow: "0 0 10px rgba(57, 255, 20, 0.3)",
                    }}
                  >
                    Join Existing Room
                  </h4>
                  <div className="gap-3">
                    <input
                      type="text"
                      placeholder="ENTER ROOM ID"
                      value={inputRoomId}
                      onChange={(e) =>
                        setInputRoomId(e.target.value.toUpperCase())
                      }
                      maxLength={6}
                      className="form-control1"
                      style={{
                        background: "rgba(0, 0, 0, 0.3)",
                        border: "1px solid rgb(0 255 65 / 20%)",
                        borderRadius: "8px",
                        color: "#00ff41",
                        fontSize: "1rem",
                        width: "100%",
                        padding: "10px",
                        fontWeight: "bold",
                        textAlign: "center",
                        //   letterSpacing: "1px",
                      }}
                    />
                    <button
                      onClick={() => joinGame(inputRoomId)}
                      className="btn"
                      disabled={!inputRoomId || inputRoomId.length !== 6}
                      style={{
                        background:
                          "linear-gradient(135deg, #00ff41 0%, #39ff14 100%)",
                        border: "none",
                        borderRadius: "5px",
                        color: "black",
                        fontWeight: "bold",
                        width: "100%",
                        marginTop: "10px",
                        fontSize: "1rem",
                        textTransform: "uppercase",
                        minWidth: "80px",
                        boxShadow: "0 4px 8px rgba(0, 255, 65, 0.3)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) => {
                        if (!e.target.disabled) {
                          e.target.style.transform = "translateY(-1px)";
                          e.target.style.boxShadow =
                            "0 6px 12px rgba(0, 255, 65, 0.4)";
                        }
                      }}
                      onMouseOut={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                          "0 4px 8px rgba(0, 255, 65, 0.3)";
                      }}
                    >
                      Join
                    </button>
                  </div>
                  <p
                    className="text-center mt-2 mb-0"
                    style={{
                      color: "rgb(161 166 162)",
                      fontSize: "0.9rem",
                      fontStyle: "italic",
                    }}
                  >
                    Enter the 6-character room code to join a friend's game
                  </p>
                </div>

                {/* <div className="text-center mt-4">
                <p
                  style={{
                    color: "rgb(161 166 162)",
                    fontSize: "0.9rem",
                    margin: "0",
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                  }}
                >
                  🏆 Win Tokens • ⚡ Real-time Battle • 🎯 Strategic Gameplay
                </p>
              </div> */}
              </div>
            </Col>
          </Row>
        )}

        {roomId && gameStatus === "waiting" && (
          <Row className="justify-content-center align-items-center min-vh-100 m-0">
            <Col xs={12} md={8} lg={12} className="p-2">
              <div className="connect-four rounded-4 shadow-lg p-4 text-center">
                <div className="mb-4">
                  <h2
                    className="text-white mb-2"
                    style={{
                      fontSize: "2rem",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      textShadow: "0 0 15px rgba(74, 144, 226, 0.6)",
                    }}
                  >
                    Waiting for Opponent...
                  </h2>
                  <div
                    style={{
                      width: "60px",
                      height: "4px",
                      // background: "linear-gradient(90deg, #4a90e2, #7bb3f0)",
                      margin: "0 auto",
                      borderRadius: "2px",
                    }}
                  ></div>
                </div>

                <div
                  style={{
                    background: "rgba(74, 226, 114, 0.1)",
                    borderRadius: "15px",
                    padding: "25px",
                    border: "1px solid rgba(112, 214, 78, 0.3)",
                    marginBottom: "20px",
                  }}
                >
                  <p
                    className="text-white mb-3"
                    style={{
                      fontSize: "1.1rem",
                      color: "#bdc3c7",
                    }}
                  >
                    Room ID:
                  </p>
                  <p
                    className="text-white mb-3"
                    style={{
                      fontSize: "2rem",
                      fontWeight: "bold",
                      color: "#4a90e2",
                      textShadow: "0 0 10px rgba(74, 144, 226, 0.5)",
                      letterSpacing: "3px",
                    }}
                  >
                    {roomId}
                  </p>
                  <button
                    onClick={copyRoomId}
                    className="btn"
                    style={{
                      background: "rgb(25 146 7)",
                      border: "none",
                      borderRadius: "10px",
                      color: "white",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      padding: "10px 20px",
                      boxShadow: "0 4px 8px rgba(74, 144, 226, 0.3)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = "translateY(-1px)";
                      e.target.style.boxShadow =
                        "0 6px 12px rgba(74, 144, 226, 0.4)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 4px 8px rgba(74, 144, 226, 0.3)";
                    }}
                  >
                    {copySuccess || "📋 Copy Room ID"}
                  </button>
                </div>

                <p
                  style={{
                    color: "#95a5a6",
                    fontSize: "1rem",
                    marginBottom: "25px",
                    fontStyle: "italic",
                    textTransform: "uppercase",
                  }}
                >
                  Share this Room ID with your friend to start playing!
                </p>

                <button
                  onClick={startOverNewGame}
                  className="btn"
                  style={{
                    background:
                      "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                    border: "none",
                    borderRadius: "10px",
                    color: "white",
                    fontWeight: "bold",
                    padding: "12px 30px",
                    fontSize: "1rem",
                    textTransform: "uppercase",
                    boxShadow: "0 4px 8px rgba(231, 76, 60, 0.3)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.boxShadow =
                      "0 6px 12px rgba(231, 76, 60, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 4px 8px rgba(231, 76, 60, 0.3)";
                  }}
                >
                  BACK
                </button>
              </div>
            </Col>
          </Row>
        )}

        {roomId && gameStatus === "playing" && (
          <Row className="justify-content-center align-items-center min-vh-100 m-0">
            <Col xs={12} md={8} lg={10} className="p-4">
              <div className="connect-four rounded-4 shadow-lg p-4">
                <h2 className="text-center mb-3 text-uppercase text-white welcome-text">
                  Connect Four Multiplayer
                </h2>

                {/* Player color indicators */}
                <div className="d-flex justify-content-between mb-3">
                  <div
                    className="p-2 rounded-3 text-center flex-grow-1 me-2 bg-secondary bg-opacity-50"
                    style={{
                      border: isMyTurn
                        ? players.length > 0 && currentPlayerId === players[0]
                          ? "1px solid #dc3545"
                          : "1px solid #ffc107"
                        : "1px solid #6c757d",
                      boxShadow: isMyTurn
                        ? players.length > 0 && currentPlayerId === players[0]
                          ? "0 0 15px rgba(220, 53, 69, 0.6)"
                          : "0 0 15px rgba(255, 193, 7, 0.6)"
                        : "none",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      className={`fw-bold ${isMyTurn ? "text-pulse" : ""}`}
                      style={{
                        color: isMyTurn
                          ? players.length > 0 && currentPlayerId === players[0]
                            ? "#dc3545"
                            : "#ffc107"
                          : "white",

                        fontSize: isMyTurn ? "1rem" : "1rem",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {isMyTurn ? "YOUR TURN" : "YOU"}
                    </div>
                    <div className="text-white-50 small">
                      {playerColor === PLAYER_RED
                        ? "🔴 Red Player"
                        : "🟡 Yellow Player"}
                    </div>
                  </div>
                  <div
                    className="p-2 rounded-3 text-center flex-grow-1 ms-2 bg-secondary bg-opacity-50"
                    style={{
                      border: !isMyTurn
                        ? players.length > 0 && currentPlayerId === players[0]
                          ? "1px solid #dc3545"
                          : "1px solid #ffc107"
                        : "1px solid #6c757d",
                      boxShadow: !isMyTurn
                        ? players.length > 0 && currentPlayerId === players[0]
                          ? "0 0 15px rgba(220, 53, 69, 0.6)"
                          : "0 0 15px rgba(255, 193, 7, 0.6)"
                        : "none",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      className="fw-bold"
                      style={{
                        color: !isMyTurn
                          ? players.length > 0 && currentPlayerId === players[0]
                            ? "#dc3545"
                            : "#ffc107"
                          : "white",
                        textShadow: !isMyTurn
                          ? players.length > 0 && currentPlayerId === players[0]
                            ? "0 0 10px rgba(220, 53, 69, 0.8)"
                            : "0 0 10px rgba(255, 193, 7, 0.8)"
                          : "none",
                        // fontSize: !isMyTurn ? "1.1rem" : "1rem",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {!isMyTurn ? "OPPONENT'S TURN" : "OPPONENT"}
                    </div>
                    <div className="text-white-50 small">
                      {playerColor === PLAYER_YELLOW
                        ? "🔴 Red Player"
                        : "🟡 Yellow Player"}
                    </div>
                  </div>
                </div>

                {/* Timer display */}
                <div className="d-flex justify-content-between mb-3">
                  <div
                    className={`p-2 rounded ${
                      playerColor === PLAYER_RED
                        ? "bg-danger bg-opacity-25"
                        : "bg-secondary bg-opacity-25"
                    }`}
                  >
                    <span className="text-white">
                      Red: {Math.floor(redTime / 60)}:
                      {(redTime % 60).toString().padStart(2, "0")}
                    </span>
                  </div>
                  <div
                    className={`p-2 rounded ${
                      playerColor === PLAYER_YELLOW
                        ? "bg-warning bg-opacity-25"
                        : "bg-secondary bg-opacity-25"
                    }`}
                  >
                    <span className="text-white">
                      Yellow: {Math.floor(yellowTime / 60)}:
                      {(yellowTime % 60).toString().padStart(2, "0")}
                    </span>
                  </div>
                </div>

                {/* Game board */}
                <div
                  className="board1 mx-auto"
                  style={{ position: "relative" }}
                >
                  {board.map((row, rowIndex) => (
                    <div key={`row-${rowIndex}`} className="flexconnect">
                      {row.map((cell, colIndex) => (
                        <div
                          key={`cell-${rowIndex}-${colIndex}`}
                          className={`cell1 ${
                            isMyTurn &&
                            cell === null &&
                            isTopEmptyCell(rowIndex, colIndex)
                              ? "hover-highlight"
                              : ""
                          }`}
                          onClick={() => handleColumnClick(colIndex)}
                          style={{
                            cursor:
                              isMyTurn &&
                              cell === null &&
                              isTopEmptyCell(rowIndex, colIndex)
                                ? "pointer"
                                : "default",
                            transition: "all 0.3s ease",
                          }}
                          onMouseEnter={(e) => {
                            if (
                              isMyTurn &&
                              cell === null &&
                              isTopEmptyCell(rowIndex, colIndex)
                            ) {
                              e.target.style.transform = "scale(1.05)";
                              e.target.style.boxShadow =
                                "0 0 15px rgba(40, 167, 69, 0.5)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (
                              isMyTurn &&
                              cell === null &&
                              isTopEmptyCell(rowIndex, colIndex)
                            ) {
                              e.target.style.transform = "scale(1)";
                              e.target.style.boxShadow = "none";
                            }
                          }}
                        >
                          {cell && (
                            <div
                              className={`piece ${
                                cell === PLAYER_RED ? "bg-danger" : "bg-warning"
                              } ${
                                isWinningcell(rowIndex, colIndex)
                                  ? "winning"
                                  : ""
                              }`}
                              style={{
                                boxShadow: isWinningcell(rowIndex, colIndex)
                                  ? "0 0 20px rgba(255, 255, 0, 0.8)"
                                  : "0 2px 4px rgba(0,0,0,0.3)",
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>

                {/* Game status */}
                {winner && (
                  <div className="text-center mt-3">
                    <span className="text-white">
                      {winner === playerColor ? "YOU WIN!" : "YOU LOSE!"}
                    </span>
                  </div>
                )}
                {isDraw && (
                  <div className="text-center mt-3">
                    <span className="text-white">DRAW!</span>
                  </div>
                )}

                {/* Game instructions */}
                <div className="mt-3 text-center text-muted small text-uppercase">
                  <p style={{ marginBottom: "0px", color: "#6a6968" }}>
                    Drop your pieces by clicking on a column. Try to connect
                    four in a row horizontally, vertically, or diagonally!
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {(() => {
          const shouldShowPopup =
            (winner || isDraw) && gameStatus === "finished";
          return shouldShowPopup;
        })() && (
          <div className="overlay">
            <div className="full-popupfour">
              <div className="popup-content">
                <h2 className="epic">GAME OVER!</h2>
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                  className="cancel-img"
                  onClick={startOverNewGame}
                />
                <div className="row text-center">
                  <div className="col-12">
                    <div className="epic-div" style={{ padding: "30px 40px" }}>
                      <p className="pointsLabel">TOKENS EARNED</p>
                      <div className="pointsValue1">
                        <img
                          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                          alt="logo"
                        />
                        <p className="pointsNumber">{points}</p>
                      </div>
                      <p className="winner-text1">
                        {winner === playerColor
                          ? "Winner : You"
                          : isDraw
                          ? "Game Draw!"
                          : winner === "Opponent" || winner === "Disconnected"
                          ? "Opponent Disconnected"
                          : "Winner : Opponent"}
                      </p>
                    </div>
                    <p className="bottom-text">
                      Play daily to boost your score and rack up more Tokens!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showTimeoutPopup && (
          <div className="overlay">
            <div className="full-popup">
              <div className="popup-content">
                <h2 className="epic text-green" style={{ color: "#4caf50" }}>
                  No Opponent Found
                </h2>
                <p className="text-center text-white">
                  No one joined your room within the time limit.
                </p>
                <button
                  style={{ width: "50%" }}
                  onClick={() => setShowTimeoutPopup(false)}
                  className="btn btn-primary text-white"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Info Popup */}
        {showInfoPopup && (
          <div className="connect-four-info-overlay">
            <div className="connect-four-info-popup">
              <div className="connect-four-info-header">
                <h3>Connect Four Game Info</h3>
                <button
                  onClick={() => setShowInfoPopup(false)}
                  className="connect-four-info-close"
                >
                  ✕
                </button>
              </div>

              <div className="connect-four-info-content">
                <div className="info-section">
                  <h4>🎯 How to Play</h4>
                  <ul>
                    <li>Create a room or join with a 6-character Room ID</li>
                    <li>Red player moves first</li>
                    <li>Each player has 5 minutes to complete the game</li>
                    <li>Click on any column to drop your piece</li>
                    <li>Connect four pieces in any direction to win</li>
                    <li>
                      You can connect horizontally, vertically, or diagonally
                    </li>
                    <li>Block your opponent's winning moves</li>
                  </ul>
                </div>

                <div className="info-section">
                  <h4>💰 Points System</h4>
                  <ul>
                    <li>
                      <strong>Win by Connect Four:</strong> 1000-2000 $MEMETV
                      TOKENS
                    </li>
                    <li>
                      <strong>Win by Timeout:</strong> 0 $MEMETV TOKENS
                    </li>
                    <li>
                      <strong>Win by Disconnect:</strong> 0 $MEMETV TOKENS
                    </li>
                    <li>
                      <strong>Draw:</strong> 0 $MEMETV TOKENS
                    </li>
                    <li>
                      <strong>Lose:</strong> 0 $MEMETV TOKENS
                    </li>
                  </ul>
                  <p className="points-note">
                    ** Early users get lower $MEMETV TOKENS
                  </p>
                </div>

                <div className="info-section">
                  <h4>⚡ Game Features</h4>
                  <ul>
                    <li>Real-time multiplayer gameplay</li>
                    <li>5-minute timer per player</li>
                    <li>Visual piece dropping animation</li>
                    <li>Winning combination highlighting</li>
                    <li>Responsive design for all devices</li>
                    <li>Room-based matchmaking system</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </>
  );
};

export default ConnectFourWeb;
